<template>
  <div class="record">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
      <el-form-item v-if="funcView.contract_ship_shipped_list_export" style="float: right; margin-right: 0">
          <el-button class="table-set" @click.native="exportTable('shipPlanExport', { ...formSearch })">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
           ref="column"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('crm_shipped.he_tong_bian_hao')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
         <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_shipped.fa_huo_dan_hao')">
          <el-input v-model="formSearch.customShipmentNum" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_shipped.ji_hua_fa_huo_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.planDeliveryTimer" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_shipped.fa_huo_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.shipperTimer" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :tableCode="tableCode"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['deviceNum','customShipmentNum','shipmentNum','consigneeName','action']"
      >
        <template v-slot:deviceNum="scope">
          <el-popover placement="bottom" width="370" trigger="hover" v-if="scope.row.deviceList">
            <el-table :data="scope.row.deviceList">
              <el-table-column width="100" property="productCode" :label="$t('crm_shipped.chan_pin_xing_hao')"></el-table-column>
              <el-table-column width="70" property="deviceBizType" :label="$t('crm_shipped.she_bei_lei_xing')"></el-table-column>
              <el-table-column width="70" property="deviceNo" :label="$t('crm_shipped.she_bei_hao')"></el-table-column>
              <el-table-column width="100" property="bodyNum" :label="$t('crm_shipped.ji_shen_hao')"></el-table-column>
            </el-table>
            <el-button slot="reference" type="text">{{ scope.row.deviceNum }}</el-button>
          </el-popover>
          <el-button v-else type="text">{{ scope.row.deviceNum }}</el-button>
        </template>
        <template v-slot:customShipmentNum="scope">
          <div class="cell-link"  @click="onDetails(scope.row)">{{  scope.row.customShipmentNum }}</div>
        </template>
        <template v-slot:shipmentNum="scope">
          <div class="cell-link" @click="onLogisticsRecords(scope.row)">{{  scope.row.shipmentNum }}</div>
        </template>
        <template v-slot:consigneeName="scope">
          <el-popover placement="top-start" trigger="hover">
            <ul>
              <!--
                networkType 和 cellularMode都为1显示
                networkType 0和cellularMode不为1显示
                其余不显示
              -->
              <li class="cell-pop-item">
                {{ $t('crm_shipped.shou_huo_ren') }}： {{scope.row.consigneeName }}
              </li>
              <li class="cell-pop-item">
                {{ $t('crm_shipped.dian_hua') }} {{scope.row.consigneePhone }}
              </li>
              <li class="cell-pop-item">
                {{ $t('crm_shipped.di_zhi') }} {{scope.row.consigneeAddress }}
              </li>
            </ul>
            <el-button class="cell-pop" type="text" slot="reference">{{  scope.row.consigneeName }}</el-button>
          </el-popover>

        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="onlink(scope.row)" v-if="funcView.contract_ship_link">{{ funcView.contract_ship_link }}</el-button>
          <el-button type="text" size="mini" @click="editLogistics(scope.row)" v-if="funcView.contract_ship_editLogistics">{{ funcView.contract_ship_editLogistics }}</el-button>
          <el-button type="text" size="mini" @click="onReceiptCode(scope.row)" v-if="funcView.contract_ship_receiptCode">{{ funcView.contract_ship_receiptCode  }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <div class="num-info">
        <div class="item">
          {{ $t('crm_shipped.fa_huo_shu_liang') }}:<span class="sum">{{ total }}</span>
        </div>
      </div>
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      >
      </custom-page>
    </div>
    <!-- 查看发货单 -->
    <ship-itemDetail-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      :model="dialogModel1"
    ></ship-itemDetail-dialog>
    <!-- 编辑物流 -->
    <enter-logistics-no-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      :contract-delivery-id="dialogModel2.orderDeliveryId"
      @success="getTableList"
    ></enter-logistics-no-dialog>
    <!-- 查看物流信息 -->
    <ship-logistics-records-dialog
      v-if="dialogVisible3"
      :model="dialogModel3"
      @close="dialogVisible3 = false"
    ></ship-logistics-records-dialog>
    <!-- 发送收货码 -->
    <ship-receip-code-dialog
      v-if="dialogVisible4"
      :model="dialogModel4"
      @close="dialogVisible4 = false"
    ></ship-receip-code-dialog>
    <!-- 收货链接 -->
    <ship-receive-link-dialog
      v-if="dialogVisible5"
      :model="dialogModel5"
      @close="dialogVisible5 = false"
    ></ship-receive-link-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import enterLogisticsNoDialog from '@/components/enterLogisticsNoDialog.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import shipReceipCodeDialog from '@/pages/crm/components/ship_receipCode_dialog.vue';
import shipItemDetailDialog from '@/pages/crm/components/ship_itemDetail_dialog.vue';
import shipLogisticsRecordsDialog from './ship_logisticsRecords_dialog.vue';
import shipReceiveLinkDialog from './ship_receiveLink_dialog.vue';

export default {
  name: 'shipped',
  mixins: [resetFormSearchMixins],
  components: {
    enterLogisticsNoDialog,
    shipItemDetailDialog,
    shipLogisticsRecordsDialog,
    shipReceipCodeDialog,
    shipReceiveLinkDialog
  },
  props: {},
  data() {
    return {
      tableCode: 'ship_shipped',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        search: '',
        dataType: 2,
        customShipmentNum: '',
        planDeliveryTimer: [],
        planStartTime: '',
        planEndTime: '',
        shipperTimer: [],
        shipStartTime: '',
        shipEndTime: '',
      },
      tableList: [],
      totalRows: null,
      total: undefined,
      // 发货详情
      dialogVisible1: false,
      dialogModel1: {},
      // 编辑物流
      dialogVisible2: false,
      dialogModel2: {},
      // 查看物流信息
      dialogVisible3: false,
      dialogModel3: {},
      // 发送收货码
      dialogVisible4: false,
      dialogModel4: {},
      // 收货链接
      dialogVisible5: false,
      dialogModel5: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 编辑物流弹窗
    editLogistics(row) {
      this.dialogModel2 = {
        title: this.$t('crm_shipped.bian_ji_wu_liu'),
        companyName: row.logisticsCompanyName,
        companyCode: row.logisticsCompanyCode,
        orderNo: row.shipmentNum,
        orderDeliveryId: row.orderDeliveryId,
      };
      this.dialogVisible2 = true;
    },
    onLogisticsRecords(row) {
      this.dialogModel3 = {
        title: this.$t('crm_shipped.ckwlxx'),
        data: {
          shipmentNum: row.shipmentNum,
          logList: row.logisticsDetailList
          // logList: [
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 10:34 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.22 00:01 星期三', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          //   { ftime: '2023.02.21 23:24 星期二', context: '[苏州市【江苏省市场一百五二部】(0512-57357919)的蠡口(15850249975)已揽收' },
          // ],
        }
      };
      this.dialogVisible3 = true;
    },
    onReceiptCode(row) {
      const title = this.$t('crm_shipped.fa_song_shou_huo_ma');
      this.dialogModel4 = {
        title: `${title}（${row.customShipmentNum}）`,
        data: row
      };
      this.dialogVisible4 = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
      this.getTableListTotal();
    },
    getTableList() {
      this.formSearch.planStartTime = this.formSearch.planDeliveryTimer && this.formSearch.planDeliveryTimer[0] ? this.formSearch.planDeliveryTimer[0] : undefined;
      this.formSearch.planEndTime = this.formSearch.planDeliveryTimer && this.formSearch.planDeliveryTimer[1] ? this.formSearch.planDeliveryTimer[1] : undefined;
      this.formSearch.shipStartTime = this.formSearch.shipperTimer && this.formSearch.shipperTimer[0] ? this.formSearch.shipperTimer[0] : undefined;
      this.formSearch.shipEndTime = this.formSearch.shipperTimer && this.formSearch.shipperTimer[1] ? this.formSearch.shipperTimer[1] : undefined;
      this.$getJSON(apis.shipPlanPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getTableListTotal() {
      this.$getJSON(apis.shipPlanDeviceTotal, this.formSearch).then((res) => {
        this.total = res.data ? res.data.deviceNum : 0;
      });
    },
    onDetails(row) {
      this.dialogModel1 = {
        title: this.$t('crm_shipped.cha_kan_fa_huo_dan'),
        type: 'shipped',
        data: row,
      };
      this.dialogVisible1 = true;
    },
    onlink(row) {
      this.dialogModel5 = {
        title: this.$t('crm_shipped.shou_huo_lian_jie'),
        data: row,
      };
      this.dialogVisible5 = true;
    },
  },
  created() { },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();
    this.getTableList();
    this.getTableListTotal();

  },
};
</script>

<style lang="scss" scoped>
.record {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 16px;
  padding-top: 16px;

  .check-detail {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
